<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-operation-record-dialog"
        top="5vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <span v-if="year">{{ year - 1911 }}年會計作業紀錄</span>
        </template>
        <div class="container">
            <el-table :data="datas" v-loading="isLoading" empty-text="無資料">
                <el-table-column prop="operationTime" label="傳票日期" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.operationTime">{{ getOperationTimeText(scope.row.operationTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="105">
                    <template slot-scope="scope">
                        <div>{{ getOperationText(scope.row.action) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="operatorName" label="操作人" width="105"> </el-table-column>
                <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                        <div>{{ scope.row.reason || '---' }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination layout="prev, pager, next" :page-size.sync="conditions.PageSize" :total.sync="totalDataCount" :current-page.sync="conditions.PageNum" @current-change="updateData">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: 0,
        },
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            isEdited: false,

            datas: [],
            totalDataCount: 0,
            conditions: {
                TaskId: this.id,
                PageNum: 1,
                PageSize: 25,
            },
        };
    },
    methods: {
        onOpen() {
            this.isEdited = false;

            this.conditions.TaskId = this.id;
            this.updateData();
        },
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AnnualAccountingTask/GetLogList',
                    method: 'GET',
                    params: this.conditions,
                });
                this.datas = resp.data.items;

                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        async onBeforeClose() {
            this.$emit('close', this.isEdited);
        },

        getOperationText(action) {
            switch (action) {
            case 0:
                return '鎖定';
            case 1:
                return '取消鎖定';
            case 2:
                return '關帳';
            case 3:
                return '取消關帳';
            default:
                return '未知操作';
            }
        },
        getOperationTimeText(date) {
            return moment(date).format('YYYY-MM-DD HH:mm');
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-operation-record-dialog {
    .container {
        padding: 40px 20px 0;
    }
    .right {
        text-align: right;
        margin: 0 20px 20px;
    }
    .pagination {
        text-align: center;
        padding: 40px 0 20px;
    }
}
</style>
